import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { ACCOUNT_PURCHASES_MODULE, DEFAULT_COLUMN } from "../constants/accountSettingsConstants";

export const setPurchasePreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: ACCOUNT_PURCHASES_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
